document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.best-sellers-carousel-wrapper');

    carousels.forEach(wrapper => {
        initCarousel(wrapper);
    });

    function initCarousel(wrapper) {
        const track = wrapper.querySelector('.best-sellers-track');
        const slides = wrapper.querySelectorAll('.best-sellers-slide');
        const nextBtn = wrapper.querySelector('.best-sellers-next');
        const prevBtn = wrapper.querySelector('.best-sellers-prev');
        const autoplayInterval = parseInt(wrapper.dataset.speed) || 5000;
        
        let itemsVisible = getItemsVisible();
        const totalItems = slides.length;
        let autoplayTimer;
        let isAnimating = false;

        window.addEventListener('resize', () => {
            itemsVisible = getItemsVisible();
        });

        function getItemsVisible() {
            return window.innerWidth < 768 ? 1 : 2;
        }

        function nextSlide() {
            if (isAnimating || totalItems <= itemsVisible) return;
            isAnimating = true;

            track.style.transition = 'transform 0.5s ease-in-out';
            track.style.transform = `translateX(-${100 / itemsVisible}%)`;

            setTimeout(() => {
                track.style.transition = 'none';
                track.appendChild(track.firstElementChild);
                track.style.transform = 'translateX(0)';
                isAnimating = false;
            }, 500);
            resetAutoplay();
        }

        function prevSlide() {
            if (isAnimating || totalItems <= itemsVisible) return;
            isAnimating = true;

            track.style.transition = 'none';
            track.insertBefore(track.lastElementChild, track.firstElementChild);
            track.style.transform = `translateX(-${100 / itemsVisible}%)`;

            // Force reflow
            void track.offsetWidth;

            track.style.transition = 'transform 0.5s ease-in-out';
            track.style.transform = 'translateX(0)';

            setTimeout(() => {
                isAnimating = false;
            }, 500);
            resetAutoplay();
        }

        function startAutoplay() {
            if (totalItems <= itemsVisible) return;
            stopAutoplay();
            autoplayTimer = setInterval(nextSlide, autoplayInterval);
        }

        function stopAutoplay() {
            if (autoplayTimer) clearInterval(autoplayTimer);
        }

        function resetAutoplay() {
            stopAutoplay();
            startAutoplay();
        }

        // Event Listeners
        nextBtn.addEventListener('click', () => {
             nextSlide();
        });
        prevBtn.addEventListener('click', () => {
             prevSlide();
        });
        
        // Pause on hover
        wrapper.addEventListener('mouseenter', stopAutoplay);
        wrapper.addEventListener('mouseleave', startAutoplay);

        // Touch support (simple swipe)
        let touchStartX = 0;
        let touchEndX = 0;

        wrapper.addEventListener('touchstart', e => {
            touchStartX = e.changedTouches[0].screenX;
        }, {passive: true});

        wrapper.addEventListener('touchend', e => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, {passive: true});

        function handleSwipe() {
            if (touchEndX < touchStartX - 50) nextSlide();
            if (touchEndX > touchStartX + 50) prevSlide();
        }

        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        startAutoplay();
    }
});
